import type { UnionTypeLibelle } from "../../../techniques"

export const ModalitePedagogique = [
  'Presentielle',
  'Mixte',
  'Distance',
  'Afest',
] as const

export type ModalitePedagogique = typeof ModalitePedagogique[number]

export const ModalitePedagogiqueLibelle: UnionTypeLibelle<ModalitePedagogique> = {
  Presentielle: 'Présentielle',
  Mixte: 'Mixte',
  Distance: 'A Distance',
  Afest: 'AFEST',
} as const
